export const isRotationLengthMirrored = (rotation: string | undefined | null) => {
    if(!rotation) return null;

    const [onboardWeeks, offBoardWeeks] = rotation.split('/');
    if(onboardWeeks === offBoardWeeks) return true;
    return false;
};
